// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
__webpack_require__.O(undefined, ["styles/app","styles/editor"], () => (__webpack_require__("./assets/scripts/app.js")))
__webpack_require__.O(undefined, ["styles/app","styles/editor"], () => (__webpack_require__("./assets/styles/app.scss")))
var __webpack_exports__ = __webpack_require__.O(undefined, ["styles/app","styles/editor"], () => (__webpack_require__("./assets/styles/editor.scss")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
